module.exports = __webpack_public_path__ + "img/responseDelay.9e5b9c2.svg";